/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Test
 * test for applicants to analytics team
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AnswerUpdatePayloadRequest
 */
export interface AnswerUpdatePayloadRequest {
    /**
     * 
     * @type {number}
     * @memberof AnswerUpdatePayloadRequest
     */
    attempt: number;
    /**
     * 
     * @type {number}
     * @memberof AnswerUpdatePayloadRequest
     */
    question: number;
    /**
     * 
     * @type {string}
     * @memberof AnswerUpdatePayloadRequest
     */
    text: string;
    /**
     * 
     * @type {number}
     * @memberof AnswerUpdatePayloadRequest
     */
    mcAnswer?: number;
}

/**
 * Check if a given object implements the AnswerUpdatePayloadRequest interface.
 */
export function instanceOfAnswerUpdatePayloadRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "attempt" in value;
    isInstance = isInstance && "question" in value;
    isInstance = isInstance && "text" in value;

    return isInstance;
}

export function AnswerUpdatePayloadRequestFromJSON(json: any): AnswerUpdatePayloadRequest {
    return AnswerUpdatePayloadRequestFromJSONTyped(json, false);
}

export function AnswerUpdatePayloadRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnswerUpdatePayloadRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'attempt': json['attempt'],
        'question': json['question'],
        'text': json['text'],
        'mcAnswer': !exists(json, 'mc_answer') ? undefined : json['mc_answer'],
    };
}

export function AnswerUpdatePayloadRequestToJSON(value?: AnswerUpdatePayloadRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'attempt': value.attempt,
        'question': value.question,
        'text': value.text,
        'mc_answer': value.mcAnswer,
    };
}

